function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnits = function SvgUnits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6,29.38v1.74a.88.88,0,0,1-.86.88H30.47a.87.87,0,0,1-.87-.87h0V18.88a.87.87,0,0,1,.86-.88h5.28a.87.87,0,0,1,.88.86v1.76H34.19a.22.22,0,0,0-.22.22v.44a.22.22,0,0,0,.22.22H36.6v1.75H34.19a.22.22,0,0,0-.22.22v.44a.21.21,0,0,0,.21.21H36.6v1.76H34.19a.2.2,0,0,0-.22.2h0v.44a.22.22,0,0,0,.22.22H36.6V28.5H34.19a.22.22,0,0,0-.22.22v.44a.22.22,0,0,0,.22.22Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.26,32H14.51a1.22,1.22,0,0,1-1.09-1.55l1.71-6.85a.77.77,0,0,1,.73-.6h1.41a2.37,2.37,0,0,1-.14-.75,2.25,2.25,0,0,1,4.5,0,2.12,2.12,0,0,1-.14.75h1.42a.77.77,0,0,1,.72.6l1.71,6.85A1.2,1.2,0,0,1,24.26,32Zm-4.13-9.75a.75.75,0,1,0-.75.75A.75.75,0,0,0,20.13,22.25Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/units.7c85abf0.svg";
export { ForwardRef as ReactComponent };